import { shallowMount } from "@vue/test-utils";
import CustomInputGroup from "@/components/core/custom/CustomInputGroup";

describe("CustomInputGroup component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CustomInputGroup, {
      slots: {
        default: "<div>Texto mock para $slots</div>"
      }
    });
  });

  it("Renders del component CustomInputGroup", () => {
    expect(wrapper.exists()).toBe(true);
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
